import { chakra } from "@chakra-ui/react";

function CategoryForm(props) {
  return (
    <chakra.form
      flexGrow="1"
      overflowY="auto"
      overflowX="visible"
      paddingBlockEnd="4"
      paddingInline="2"
      marginInline="-2"
      {...props}
    />
  );
}

export default CategoryForm;
